const isObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const hasAccountId = (account) =>
  isObject(account) &&
  typeof account.id === 'string' &&
  account.id.trim().length > 0;

export const resolveSelectedAccount = (metadata) => {
  if (!isObject(metadata) || !Array.isArray(metadata.accounts)) {
    return { kind: 'none' };
  }

  const { accounts } = metadata;
  if (
    accounts.length === 0 ||
    !Array.from(accounts).every(hasAccountId)
  ) {
    return { kind: 'none' };
  }

  return accounts.length === 1
    ? { kind: 'single', account: accounts[0] }
    : { kind: 'choose', accounts };
};

export const accountSummary = (account, index) => {
  const name = isObject(account)
    ? typeof account.name === 'string' && account.name.trim()
      ? account.name
      : typeof account.official_name === 'string' && account.official_name.trim()
        ? account.official_name
        : 'Account'
    : 'Account';
  const mask =
    isObject(account) && typeof account.mask === 'string'
      ? account.mask
      : undefined;
  const label =
    typeof mask === 'string' && mask.length > 0
      ? `${name} ••••${mask}`
      : name;

  return {
    index,
    label,
    mask,
    subtype:
      isObject(account) && typeof account.subtype === 'string'
        ? account.subtype
        : undefined,
  };
};

export const redactForTelemetry = (input = {}) => {
  const safeInput = isObject(input) ? input : {};
  const safeMetadata = isObject(safeInput.metadata) ? safeInput.metadata : {};
  const safeError = isObject(safeInput.error) ? safeInput.error : {};
  const accounts = Array.isArray(safeMetadata.accounts)
    ? safeMetadata.accounts
    : [];
  const institution = isObject(safeMetadata.institution)
    ? safeMetadata.institution.name
    : undefined;

  return {
    institution_name:
      typeof safeMetadata.institution_name === 'string'
        ? safeMetadata.institution_name
        : typeof institution === 'string'
          ? institution
          : undefined,
    account_count: accounts.length,
    mask:
      accounts.length > 0 &&
      isObject(accounts[0]) &&
      typeof accounts[0].mask === 'string'
        ? accounts[0].mask
        : undefined,
    error_code:
      typeof safeError.error_code === 'string'
        ? safeError.error_code
        : undefined,
    error_type:
      typeof safeError.error_type === 'string' ? safeError.error_type : undefined,
  };
};
